import { render, staticRenderFns } from "./addSize.vue?vue&type=template&id=442a161a&scoped=true"
import script from "./addSize.vue?vue&type=script&lang=js"
export * from "./addSize.vue?vue&type=script&lang=js"
import style0 from "./addSize.vue?vue&type=style&index=0&id=442a161a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a161a",
  null
  
)

export default component.exports